const attachments = [
  {
    id: 1,
    title: "Cold Calling Form",
    description: "Formularz wspierający strukturę i przygotowanie rozmów cold callingowych.",
    filename: "Cold Calling Form_CCF.pdf",
    type: "PDF",
  },
];

export default attachments;
